export const ERROR_MESSAGES = {
  '403': {
    header: 'Forbidden!',
    message:
      'You do not have permission access to this page (Status Code: 403)',
    buttonType: 'href',
    buttonText: 'Login',
    buttonHref: '/login',
  },
  '404': {
    header: "Couldn't find it. . .",
    message:
      "We tried to find the page that you're looking for, but looks like it's been removed or does not exist (Status Code: 404)",
    buttonType: 'link',
    buttonText: 'Take me home',
    buttonHref: '/',
  },
  '500': {
    header: "Something's wrong.",
    message:
      "Well, shucks. Something seems to have gone wrong on our servers. This normally doesn't happen, and I'm fixing it right now. Hang in there! (Status Code: 500)",
    buttonType: 'link',
    buttonText: 'Take me home',
    buttonHref: '/',
  },
};
